<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-20 11:13:42
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button
          @click="toAddManuscript"
          v-if="codeData.indexOf('22') != -1"
          type="primary"
          >创作稿件</el-button
        >
        <div v-if="codeData.indexOf('343') != -1"  class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item  key="1"> 删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
         <a-range-picker style="margin-right:12px" showTime v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
        <el-select
          multiple
          clearable
          v-model="value"
          placeholder="按模型选择"
        >
          <el-option
            :key="index"
            v-for="(item, index) in listPageData"
            :label="item.modelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
            clearable
            style="margin-left: 10px"
            v-model="states"
            multiple
            collapse-tags
            placeholder="按稿件状态筛选"
          >
           
            <el-option label="草稿" value="0"> </el-option>
            <el-option label="审核中" value="1"> </el-option>
            <el-option label="审核通过" value="2"> </el-option>
            <el-option label="审核失败" value="3"> </el-option>
             <el-option label="已发布" value="4"> </el-option>
            <el-option label="已下线" value="5"> </el-option>
            
        </el-select>
        <a-input
          v-model:value="valueName"
          placeholder="请输入标题内容"
          style="width: 173px; margin-left: 12px; margin-right: 12px"
        />
        <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @handleTableChange="handleTableChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
      disRow="state"
      :disState="[1,2,4]"
    >
      <template v-slot:columnName="scopeVal">
        <div
          @click="openColumn(scopeVal.scope)"
          v-if="scopeVal.scope.number && codeData.indexOf('177') != -1"
          class="column-style"
        >
          <el-popover
            placement="left-start"
            title=""
            width="380"
            @show="showData(scopeVal.scope.id)"
            trigger="hover"
          >
            <div>
              <div class="title-top">
                <div class="title-top-left">预览关联栏目</div>
                <div class="title-top-right">点击标签操作发布和下线</div>
              </div>
              <div class="item-one" v-for="(item, index) in showDataReq">
                 <span v-if="item.parentsName">{{ index + 1 }}. {{ item.parentsName.split(",").join(">") }}</span>
              </div>
            </div>
            <el-button class="column-number" slot="reference"
              >共{{ scopeVal.scope.number }}个</el-button
            >
          </el-popover>
        </div>
        <div class="column-numberTwo" v-if="!scopeVal.scope.number">-</div>
      </template>
      <template v-slot:mediaData="scopeVal">
        <div
            @click="openNews(scopeVal.scope)"
            v-if="scopeVal.scope.mediaCount && codeData.indexOf('244') != -1"
            class="column-style"
        >
          <el-popover
              placement="left-start"
              title=""
              width="380"
              trigger="hover">
            <div>
              <div class="title-top">
                <div class="title-top-left">预览关联新媒体</div>
                <div class="title-top-right">点击标签操作发布和下线</div>
              </div>
              <div class="item-one" v-for="(item,index) in scopeVal.scope.mediaData.split(',')">{{index+1}}. {{item}}</div>
            </div>
            <el-button class="column-number" slot="reference">共{{ scopeVal.scope.mediaCount }}个</el-button>
          </el-popover>
        </div>
        <div class="column-numberTwo" v-if="!scopeVal.scope.mediaCount">-</div>
      </template>
      <template v-slot:titleName="scopeVal">
         <div style="display: flex">
            <div v-if="scopeVal.scope.state == 2"
                style="min-width:60px"
                class="title-box"
              >
                审核通过
              </div>
              <div v-if="scopeVal.scope.state == 3"
                style="min-width:60px"
                class="title-box"
              >
                审核失败
              </div>
               <div v-if="scopeVal.scope.state == 0"
                class="title-box"
              >
                草稿
              </div>
               <div v-if="scopeVal.scope.state == 1"
                class="title-box"
              >
                审核中
              </div>
                <div v-if="scopeVal.scope.state == 4"
                class="title-box"
              >
                已发布
              </div>
                <div v-if="scopeVal.scope.state == 5"
                class="title-box-two"
              >
                已下线
              </div>
              <div class="titletxt">{{scopeVal.scope.title}}</div>
         </div>
      </template>
      <template v-slot:stateRizhi="scopeVal">
        <a-popover trigger="click">
          <div class="content" slot="content">
            <div class="open-style" v-for="(item, index) in seeData">
              <div>操作人: {{ item.name || "--" }}</div>
              <div>操作时间: {{ item.time || "--" }}</div>
              <div>描述: {{ item.content || "--" }}</div>
            </div>
          </div>
          <a v-if="codeData.indexOf('23') != -1" @click="see(scopeVal.scope)"
            >查看</a
          >
        </a-popover>
      </template>
      <template v-slot:operation="scopeVal">
        <div style="display: flex">
          <div
            @click="editAdmin(scopeVal.scope)"
            class="btnTwo"
            style="margin-right: 14px;"
            v-if="scopeVal.scope.state != 1 && codeData.indexOf('24') != -1"
          >
            编辑
          </div>
          <div
            @click="open(scopeVal.scope)"
            class="btnThree"
            v-if="
              codeData.indexOf('25') != -1 &&
              (scopeVal.scope.state == 0 ||
                scopeVal.scope.state == 5 ||
                scopeVal.scope.state == 2 ||
                scopeVal.scope.state == 3)
            "
          >
            删除
          </div>
          <el-popover v-else placement="left-start" trigger="hover">
            <div>
              <div>需将稿件在所有栏目中下线后才可删除</div>
            </div>
            <el-button class="btnFour" slot="reference">删除</el-button>
          </el-popover>
        </div>
      </template>
    </coententTable>
    <el-dialog
      title="确认删除稿件?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="handleClose"
      top="17%"
    >
      <span>确认删除此条稿件吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button type="danger" @click="deleteOne()">确认删除</el-button>
      </span>
    </el-dialog>
      <el-dialog
      title="查看关联栏目"
      :visible.sync="dialogVisibleColum"
      width="535px"
      class="column-box column-box-two"
      :before-close="handleCloseColum"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >若需彻底删除栏目关联，请到稿件编辑中进行设置
      </div>
      <coententTable
        :columns="columnsTwo"
        :dataSource="dataSourceColunm"
         :customSlot="customSlotTwo"
         :loading='isFabu'
         :y="300"
      >
      <template v-slot:state="scopeVal">
        {{
          scopeVal.scope.state == 0
            ? "草稿"
            : scopeVal.scope.state == 1
            ? "审核中"
            : scopeVal.scope.state == 2
            ? "审核通过"
            : scopeVal.scope.state == 3
            ? "审核失败"
            : scopeVal.scope.state == 4
            ? "已发布"
            : "下线"
        }}
      </template>
         <template v-slot:operation="scopeVal">
           <div style="display: flex;">
                <div
           v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5"
            @click="release(scopeVal.scope)"
            class="btnTwo"
            >发布</div
          >
          <div  v-if="scopeVal.scope.state == 4" class="btnFour">发布</div>
          <div
           v-if="scopeVal.scope.state == 4"
            @click="Offline(scopeVal.scope)"
            style="margin-left: 20px"
            class="btnTwo"
            >下线</div
          >
           <div style="margin-left:20px"  v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5" class="btnFour">下线</div>
           </div>
        </template>
      </coententTable>
      <div class="footer-style">
          <a-button @click="allXiaXian" size='large' type="primary">
            全部发布
          </a-button>
          <a-button @click="allFabu" style="margin-left:12px" size='large' >全部下线</a-button>
      </div>
    </el-dialog>
    <el-dialog
        title="查看关联新媒体"
        :visible.sync="dialogVisibleNews"
        width="700px"
        class="column-box"
        :before-close="handleCloseNews"
        top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >若需彻底删除栏目关联，请到对应新媒体平台进行操作
      </div>
      <coententTable
          :columns="columnsThree"
          :dataSource="dataSourceNews"
          :customSlot="customSlotNews"
      >
        <template v-slot:type="scopeVal">
          {{
            scopeVal.scope.type == 1
                ? "公众号"
                : scopeVal.scope.type == 2
                    ? "微博"
                    : scopeVal.scope.type == 3
                        ? "头条" : "抖音"
          }}
        </template>
        <!-- <template v-slot:state="scopeVal">
          {{
            scopeVal.scope.state == 0
              ? "已提交"
              : scopeVal.scope.state == 1
              ? "已存入草稿发布失败"
              : scopeVal.scope.state == 2
              ? "存入草稿失败"
              : scopeVal.scope.state == 3
              ? "发布中"
              : scopeVal.scope.state == 4
              ? "发布成功"
              : scopeVal.scope.state == 5
              ? "发布失败"
              : scopeVal.scope.state == 6
              ? "账户未授权"  : scopeVal.scope.state == 9?"审核通过"
              : "无封面图片"
          }}
        </template> -->
        <template v-slot:operation="scopeVal">
          <div style="display:flex">
            <div
                v-if="[1,2,5,7,9].indexOf(scopeVal.scope.state) != -1 && codeData.indexOf('245') != -1"
                @click="releaseNews(scopeVal.scope)"
                style="margin-right: 20px"
                class="btnTwo"
            >发布</div
            >
            <div class="btnFour"  v-if="[1,2,5,7,9].indexOf(scopeVal.scope.state) == -1 && scopeVal.scope.state != 6">发布</div>
            <div
                v-if="scopeVal.scope.state == 6 && codeData.indexOf('246') != -1"
                @click="authorization(scopeVal.scope)"
                class="btnTwo"
                style="width:84px"
            >重新授权</div
            >
          </div>

        </template>
      </coententTable>
    </el-dialog>
  </div>
</template>

<script>
import {
  listPage,
  selectListById,
  deleteById,
  selectMyListPage,
  selectList,
  toColumnExamine,
  toColumnOffline, selectMediaConfig, wxRelease, getPreAuthCodet, getOauth, getDouyinCode,
} from "../all_manuscripts";
import coententTable from "@/components/coentent_table.vue";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      selectName: "标题",
      valueName: "",
      selectValue: 1,
      height: 0,
      time: [],
      value: [],
      dataSourceNews: [],
      isFabu: false,
      columnsThree: [
        {
          title: "关联新媒体",
          dataIndex: "mediaName",
          ellipsis: true,
          width: 120,
        },
        {
          title: "所属平台",
          dataIndex: "type",
          ellipsis: true,
          scopedSlots: { customRender: "type" },
          width: 120,
        },
        {
          title: "状态",
          dataIndex: "publishMsg",
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 194,
          fixed: "right",
        },
      ],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
         scopedSlots: { customRender: "titleName" },
      },
        {
          title: "内容模型",
          dataIndex: "modelNames",
          width: 120,
          ellipsis: true,
        },
        {
          title: "关联栏目",
          dataIndex: "columnName",
          scopedSlots: { customRender: "columnName" },
          width: 120,
        },
        {
          title: "关联新媒体",
          dataIndex: "mediaData",
          key: "mediaData",
          scopedSlots: { customRender: "mediaData" },
          width: 120,
        },
        {
          title: "创作人员",
          dataIndex: "manName",
          width: 120,
        },
         {
          title: "创作时间",
          dataIndex: "createTime",
          width: 200,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 174,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "columnName",
          customRender: "columnName",
        },
        {
          name: "titleName",
          customRender: "titleName",
        },
        {
          name: "mediaData",
          customRender: "mediaData",
        },
      ],
      columnsTwo: [
        {
          title: "关联栏目",
          dataIndex: "columnName",
            ellipsis: true,
           width: 120,
        },
        {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
            ellipsis: true,
           width: 120,
        },
        {
          title: "操作",
          dataIndex: "title",
          scopedSlots: { customRender: "action" },
         fixed: "right",
          width: 174,
        },
      ],
      customSlotTwo: [
        {
          name: "state",
          customRender: "state",
        },
      ],
      customSlotNews: [
        {
          name: "state",
          customRender: "state",
        },
        {
          name: "type",
          customRender: "type",
        },
      ],
      rowKeys: [],
      seeData: {},
      states:[],
      loading: false,
      isSelectRow: true,
      listPageData: [],
      loading: false,
      dialogVisibleTwo: false,
      dataSourceColunm: [],
      itemColumn: {},
      dialogVisibleColum: false,
      codeData: [],
      dialogVisibleNews: false,
      width: 0,
      selectChooseIds: [],
      showDataReq: [],
    };
  },
  components: {
    coententTable,
  },
  props: ["type"],
  mounted() {
    let current = sessionStorage.getItem("myManuscriptsPage");
    if (current) {
      this.pagination.current = current;
    }
    this.getList();
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    handleCloseColum() {
      this.dialogVisibleColum = false;
      //this.getList();
    },
    showData(id) {
      this.showDataReq = [];
      selectList({ id: id }).then((res) => {
        if (res.code == 0) {
          this.showDataReq = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    release(item) {
      this.isFabu = true;
      toColumnExamine([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
               this.isFabu = false;
            }
          });
        }
      });
    },
     handleMenuClick(e) {
      let content = "";
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      if (e.key == 1) {
        content = "确定批量删除吗?";
      }
      const _this = this;
      this.$confirm({
        title: "操作提示",
        content,
        centered: true,
        onOk() {
           return new Promise((resolve, reject) => {
             if (e.key == 1) {
              deleteById({
                idList: _this.rowKeys,
              }).then((res) => {
                if (res.code == 0) {
                  _this.getList();
                  _this.rowKeys = [];
                  setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                }
              });
            }
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
        class: "test",
      });
    },
    openNews(item) {
      this.getNewsList(item);
      this.dialogVisibleNews = true;
    },
    handleCloseNews() {
      this.dialogVisibleNews = false;
      this.getList();
    },
    getNewsList(item) {
      selectMediaConfig({
        id: item.id || item.manuscriptId,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSourceNews = res.data;
        }
      });
    },
    allXiaXian() {
      this.isFabu = true;
      let array = [];
      this.dataSourceColunm.forEach((element) => {
        array.push({
          manuscriptId: this.itemColumn.id,
          id: element.id,
          columnId: element.columnId,
        });
      });
      toColumnExamine(array).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    allFabu() {
      this.isFabu = true;
      let array = [];
      this.dataSourceColunm.forEach((element) => {
        array.push({
          manuscriptId: this.itemColumn.id,
          id: element.id,
          columnId: element.columnId,
        });
      });
      toColumnOffline(array).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
        this.isFabu = false;
      });
    },
    Offline(item) {
      this.isFabu = true;
      toColumnOffline([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
                this.isFabu = false;
            }
          });
        }
      });
    },
    openColumn(item) {
      this.dialogVisibleColum = true;
      this.itemColumn = item;
       this.dataSourceColunm = [];
       this.isFabu = true;
      selectList({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.dataSourceColunm = res.data;
           this.isFabu = false;
        }
      });
    },
    releaseNews(item) {
      wxRelease({
        manuscriptId: item.manuscriptId,
        releaseId: item.releaseId,
        mediaId: item.mediaId,
        configId: item.configId,
        mediaName: item.mediaName,
      }).then((res) => {
        if (res.code == 0) {
          this.getNewsList(item);
        }
      });
    },
    authorization(item) {
      if (item.type == 1) {
        getPreAuthCodet({ id: sessionStorage.getItem("siteId") }).then(
            (res) => {
              if (res.code == 0) {
                window.open(`${res.data.oauthUrl}`);
              }
            }
        );
      }
      if (item.type == 2) {
        getOauth({ id: sessionStorage.getItem("siteId") }).then((res) => {
          if (res.code == 0) {
            window.open(`${res.data.oauthUrl}`);
          }
        });
      }
      if (item.type == 3) {
      }
      if (item.type == 4) {
        getDouyinCode({ id: sessionStorage.getItem("siteId") }).then((res) => {
          if (res.code == 0) {
            window.open(`${res.data.oauthUrl}`);
          }
        });
      }
    },
    toAddManuscript() {
      let routeData = this.$router.resolve({ path: "/index/content/manuscripts" });
      window.open(routeData.href, '_blank');
    },
    getListPage() {
      listPage({
        siteId: sessionStorage.getItem("siteId"),
        current: 1,
        size: 100000000,
      }).then((res) => {
        if (res.code == 0) {
          this.listPageData = JSON.parse(JSON.stringify(res.data.records));
        }
      });
    },
    see(item) {
      selectListById({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
      sessionStorage.setItem("manuscriptsType", this.type);
      sessionStorage.setItem("myManuscriptsPage", this.pagination.current);
     let routeData =  this.$router.resolve({
        path: "/index/content/manuscripts_edit",
        query: {
          id: item.id,
          title: "编辑稿件",
          islast: true,
          type: this.type,
          isAllman: true,
        },
      });
       window.open(routeData.href, '_blank');
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      selectMyListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        siteId: sessionStorage.getItem("siteId"),
        type: this.selectValue,
        labelType: 1,
        modelId: this.value.join(","),
        states: this.states.join(","),
        startTime,
        endTime,
        managerId: JSON.parse(sessionStorage.getItem("userInfo")).id,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
        sessionStorage.removeItem("myManuscriptsPage");
        sessionStorage.removeItem("manuscriptsType");
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    handleTableChange() {},
    handleClose() {
      this.dialogVisibleTwo = false;
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    deleteOne() {
      deleteById({
        idList: [this.item.id],
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.rowKeys = [];
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon-st-doc-edit:before {
      color: #fff;
      margin-right: 5px;
      font-size: 16px;
    }
    .batch-operation {
      margin-left: 10px;
      margin-right: 12px;
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.column-style {
  display: flex;
  cursor: pointer;
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
.title-box {
  min-width: 50px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background-color: rgba(240, 249, 235, 1);
  color: rgba(103, 194, 58, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(103, 194, 58, 0.3);
  text-align: center;
  margin-right: 14px;
  }
  .title-box-two{
    width: 50px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background-color: rgba(244, 244, 245, 1);
    color: rgba(144, 147, 153, 1);
    font-size: 12px;
    font-family: Roboto;
    border: 1px solid rgba(211, 212, 214, 1);
    margin-right: 14px;
  }
  .titletxt{
   overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;

  }
</style>